export const CREATE_RFQ = `
mutation CreateRfq($amount: String!, $currency: String!) {
  createRfq(amount: $amount, currencyName: $currency) { 
    rfq 
    { 
      id
      txRef 
      email
      iban
      status
      buyRate
      sellRate
      sekDeposit
      eurRequest
      createdAt
      settledAt
      clientPid
      kycData
    } 
  }
}
`;

export const TOPUP_RFQ = `
mutation topupRfq ($amount: String!, $currency: String!, $status: String!, $txRef: String!) {
  topupRfq(amount: $amount, currencyName: $currency, status: $status, txRef: $txRef) { 
    status 
  } 
}`;

export const UPDATE_IBAN = `
mutation updateIBAN ($country: String!, $currency: String!, $iban: String!, $owner: String!) {
  updateIban(bankingCountry: $country, currencyName: $currency, iban: $iban, ownersName: $owner) { 
    success 
  }
}`;

export const WHITELIST_ADDRESS = `
mutation whitelistAddress ($address: String!, $label: String!) {
  whiteList(address: $address, label: $label) {
    success
  }
}`;

export const UPDATE_WEBHOOK = `mutation updateWebhook ($webhook: String!, $publicKey: String!) {
  updateWebhook(webhook: $webhook, publicKeyId: $publicKey) { 
    success 
  }
}`;

export const CREATE_CLIENT_PAYOUT = `mutation createClientPayout ($input: ClientPayoutInput!) {
  createClientPayout(paymentInfo: $input) { 
    name
    recipientType
    iban
    bic
    recipientBankCountry
    currency
    amount
    paymentReference
    recipientCountry
    addressLine1
    addressLine2
    city
    postalCode    
  }
}`;

export const CREATE_COUNTERPARTY = `mutation createCounterparty ($merchantId: String!, $input: CounterpartyPayoutInput!) {
  createCounterparty(merchantId: $merchantId, paymentInfo: $input) {
    counterpartyId
  }
}`;

export const CREATE_BATCHED_CLIENT_PAYOUT = `
mutation createBatchedClientPayout($paymentInfoList: [ClientPayoutInput]!) {
  createBatchedClientPayout (paymentInfoList: $paymentInfoList) {
    result {
      name
      recipientType
      iban
      bic
      recipientBankCountry
      currency
      amount
      paymentReference
      recipientCountry
      addressLine1
      addressLine2
      city
      postalCode
      error
    }
  } 
}
`;
export const ADD_COUNTERPARTY = `
mutation addCounterparty ($input: ClientPayoutInput!) {
  addCounterparty(clientPayoutData: $input) {
    clientPayout {
      name
      recipientType
      iban
      bic
      recipientBankCountry
      currency
      amount
      paymentReference
      recipientCountry
      addressLine1
      addressLine2
      city
      postalCode
    }
  }
}`;

export const CREATE_PAYIN = `
  mutation createPayin ($amount: String, $ccyName: String) {
    createPayin(amount: $amount, ccyName: $ccyName) {
      url
    }
  }
`;

export const INIT_PAYLINK = `
  mutation initPayLink (
    $bank: String, 
    $personId: String, 
    $authMode: String, 
    $txRef: String) {
    initPayLink(
      bank: $bank, 
      personId: $personId, 
      authMode: $authMode, 
      txRef: $txRef) {
      rfqId
      opId
    }
  }
`;

export const CONFIRM_ACCOUNT = `
mutation confirmAccount (
  $balance: String!, 
  $currency: String!, 
  $origin: String!, 
  $originAccount: String!, 
  $task: String!
) {
  confirmAccount(
    balance: $balance, 
    currency: $currency, 
    origin: $origin,
    originAccount: $originAccount,
    task: $task
  ) {
    status
  }
}
`;

export const REJECT_ACCOUNT = `
mutation rejectAccount ($task: String) {
  rejectAccount(task: $task) {
    status
  }
}
`;

export const CANCEL_PAYMENT = `
mutation cancelPay ($taskId: String, $txRef: String, $realCancel: Boolean) {
  cancelPay(task: $taskId, ref: $txRef, realCancel: $realCancel) {
    status
  }
}
`;

export const CHALLENGE_PI = `
mutation createPi ($amount: String, $currency: String, $clientId: String) {
  createPi(amount: $amount, currencyName: $currency, clientId: $clientId) {
    payment {
      id
    }
    challange
  }
}
`;

export const REVOKE_API_KEY = (kid: string) => `
{ 
    revokeApiKey(kid: "${kid}")
}
`;

export const REQUEST_KYC_APPROVAL = `
mutation requestKycApproval ($personId: String) {
  requestKycApproval(personId: $personId) {
    task
  }
}`;

export const UPDATE_MERCHANT_IBAN = `
mutation (
$email: String!,
$iban: String,
$bban: String,
$accountId: String,
$orgNumber: String,
$country: String,
$friendlyName: String
$internalId: String
) {
  updateMerchant (
friendlyName: $friendlyName,
email: $email,
iban: $iban,
bban: $bban,
accountId: $accountId, 
orgNumber: $orgNumber,
country: $country,
internalId: $internalId
  ) {
    success, 
  }
}`;

export const VERIFY_LINK = `
mutation verifyLink ($personId: String) {
  verifyLink (personId: $personId) {
    verify 
  }
}`;

export const CREATE_BATCH = `
mutation createBatch ($startTime: DateTime!, $endTime: DateTime!) {
  createBatch(startTime: $startTime, endTime: $endTime) {
    success
    message
    batchId
  }
}`;

export const UPDATE_WITHDRAWAL_STATUS = `mutation updateWithdrawalStatus ($input: UpdateWithdrawalStatusInput!) {
  updateWithdrawalStatus(input: $input) { 
    success
    message
  }
}`;

export const BATCH_UPDATE_WITHDRAWAL_STATUSES = `mutation batchUpdateWithdrawalStatus ($input: [WithdrawStatusInput]!) {
  batchUpdateWithdrawalStatus(input: $input) { 
    success
    message
  }
}`;
/*
class AddSubMerchant(graphene.Mutation):
    class Arguments:
        email = graphene.String(required=True)
        name = graphene.String(required=True)
        merchant_id = graphene.String(required=True)
        access_rights = graphene.JSONString(required=False)
*/
/*
        default_access_rights = {
            "can_view_clients": True,
            "can_edit_clients": False,
            "can_initiate_payouts": False,
            "can_view_transactions": True
        }
*/
export const ADD_SUB_MERCHANT = `mutation addSubMerchant (
  $email: String!, 
  $name: String!, 
  $merchantIds: [String]!, 
  $personId: String!,
  $accessRights: JSONString
) {
    addSubMerchant(
      email: $email, 
      name: $name,
      personId: $personId,
      merchantIds: $merchantIds, 
      accessRights: $accessRights    
    ) {
      success
    }
}`;

export const CREATE_SESSION = `mutation storeSession (
  $sessionId: String!, 
  $data: JSONString!
) {
    storeSession(sessionId: $sessionId, data: $data) {
      status
    }
}`;

export const EXEC_WITHDRAWAL = `mutation execWithdrawal($input: UpdateWithdrawalExecInput!) 
{
  execWithdrawal(input: $input) { 
    success
    message
  }
}
`;

export const WITHDRAW = `
mutation withdraw($input: WithdrawInput!) 
{
  withdraw(input: $input) { 
    success
    message
    transactionId
  }
}
`;
export const BANKID_PING = `mutation bankidPing 
{
  bankidPing { 
    status
  }
}
`;

export const BANKID_SCAN = `mutation bankidScan($personId: String!) 
{
  bankidScan(personId: $personId) { 
    status
    autoStartToken
  }
}
`;

export const RESUME_PI = `mutation resumePi($opId: String!, $resume: Boolean!) 
{
  resumePi(opId: $opId, resume: $resume) { 
    status
  }
}
`;

export const MARK_INVOICE_AS_PAID = `mutation markInvoicePaid($invoiceId: Int!) 
{
  markInvoicePaid(invoiceId: $invoiceId) { 
    status
  }
}
`;

export const PINGWIRE_BUMP = `mutation pingwireUpdate(
  $payoutIds: [String!] 
  $depositIds: [String!]
  $merchantId: String
) {
  pingwireUpdate(
    payoutIds: $payoutIds
    depositIds: $depositIds
    merchantId: $merchantId
  ) {
    status
    responseData
  }
}`;

export const SEB_REPORT_DUMMY = `mutation emailDummy($emails: [EmailsType!]) 
{
  emailDummy(emails: $emails) { 
    status
  }
}
`;

export const SEB_REPORT_EMAIL = `mutation dailySeb($emails: [EmailsType!], $accountId: String!, $fromDate: String!, $toDate: String!) 
{
  dailySeb(emails: $emails, accountId: $accountId fromDate: $fromDate, toDate: $toDate) { 
    status
  }
}
`;

export const ORCH_LOG_LEVEL = `mutation orchestratorSetLoglevel($logLevel: String, $banking: GenericScalar, $payouts: GenericScalar, $crypto: GenericScalar) 
{
  orchestratorSetLoglevel(logLevel: $logLevel, banking: $banking, payouts: $payouts, crypto: $crypto) { 
    status
  }
}
`;

export const ORCH_GET_LOG_LEVEL = `{
  orchestratorGetLoggerLevels
}
`;
